import React from 'react';
import { Layout, Card } from 'antd'; 
import { DatabaseOutlined, RobotOutlined, CloudServerOutlined, LineChartOutlined, ImportOutlined } from '@ant-design/icons';
import { Routes } from '../../../routes';
import { PageLinkCard } from '../../../components/pageLinkCard/PageLinkCard';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { useFeatureFlags } from '../../../featureFlags';
import { flags } from '../../../featureFlags/flags';
import { authService } from '../../../auth/authService';
import './styles.less';

const ReportingNavPage = () => {

    const breadcrumbs = [
        { name: 'Course Studio', path: Routes.Home.buildPath() },
        { name: 'Analytics' }
    ];

    const [ showAIReporting, showStaticReporting, showDataDump ] =
        useFeatureFlags( [ flags.AI_REPORTING_ENABLED, flags.STATIC_REPORTING_ENABLED, flags.DATA_EXPORT ] );

    return ( 
        <Layout className="reporting-nav-page">
            
            { /* Page header breadcrumbs */ }
            <Breadcrumbs crumbs={ breadcrumbs }/>

                <Card
                    className="reporting-content link-card"
                    title="Analytics"
                >

                    <PageLinkCard
                        disabled={ !showDataDump }
                        href={ Routes.DataExportPage.buildPath() }
                        icon={ <CloudServerOutlined />  }
                        title="Data Export"
                        description="Download your learning data as files to use in other tools"
                    />

                    <PageLinkCard
                        disabled={ !showStaticReporting }
                        href={ Routes.StaticReporting.buildPath() }
                        icon={ <DatabaseOutlined />  }
                        title="Static Reporting"
                        description="View ready-made reports on your training activity"
                    />

                    <PageLinkCard
                        disabled={ !showAIReporting }
                        href={ Routes.AIReport.buildPath() }
                        icon={ <RobotOutlined />  }
                        title="AI Reporting"
                        description="Get AI-generated insights and summaries from your data"
                    />

                    <PageLinkCard
                        href={ Routes.Stats.buildPath() }
                        icon={ <LineChartOutlined />  }
                        title="Stats"
                        description="See key metrics about your courses and learners at a glance"
                    />

                    { authService.isBiwEmployee() &&
                        <PageLinkCard
                            href={ Routes.WarehouseImports.buildPath() }
                            icon={ <ImportOutlined />  }
                            title="Warehouse Imports"
                            description="Bring external data into the platform for reporting"
                        />
                    }

                </Card>
        </Layout>
    );
};

export default ReportingNavPage;